const pricingData = {
  bankAccount: {
    number: "123-1330590247/0100",
    bank: "Komerční banka a.s."
  },
  tuition: {
    monthly: "5 650 Kč",
    period: "11 měsíců (září - červenec)",
    description: "září - červen (10 měsíců) + 1 platba za letní provoz. V létě je škola otevřená poslední týden v červenci a první tři týdny v srpnu. Neprobíhá klasická výuka, fungujeme spíše jako příměstský tábor, který někteří naši žáci využívají a jiní ne. Program plánujeme tak, abychom co nejvíce času trávili venku. Tento čas také rádi využíváme pro adaptaci nově příchozích žáků."
  },
  lunch: {
    provider: "SŠ Slavkov - Austerlitz",
    price: "80 Kč/porci",
    paymentMethod: "Platí se zpětně za celý měsíc pomocí QR kódu, který posíláme individuálně.",
    ordering: "Obědy se objednávají na další týden vždy do pátku 12:00 předchozího týdne.",
    cancellation: "V případě nemoci je možné oběd zrušit do 12 hodin předchozího dne."
  },
  extraActivities: [
    /*
    {
      name: "Jméno kroužku",
      price: "500 Kč/měsíc"
    }
    */
  ],
  paymentInfo: "Způsob platby: převodem na účet školy, vždy do 15. dne v měsíci."
};

export default pricingData; 